import React from 'react';
import { Skeleton } from '../../../components/ui/Skeleton';
import styles from './OverviewSkeleton.module.css';

/**
 * OverviewSkeleton — loading placeholder mirroring OverviewV2's card grid
 * (full-width status banner, 3/3/6 risk row, 6/6 chart rows).
 *
 * Rendered for BOTH loading phases so the page keeps one continuous
 * loading layout from hard refresh to data: while the workspace's
 * getSession fetch is in flight (projectLoading) and while OverviewV2's
 * own aggregate fetch runs.
 */
export default function OverviewSkeleton() {
  return (
    <div className={styles.grid} aria-hidden="true">
      <Skeleton className={`${styles.banner} ${styles.spanFull}`} />
      <Skeleton className={`${styles.cardSm} ${styles.span3}`} />
      <Skeleton className={`${styles.cardSm} ${styles.span3}`} />
      <Skeleton className={`${styles.cardSm} ${styles.span6}`} />
      <Skeleton className={`${styles.cardLg} ${styles.span6}`} />
      <Skeleton className={`${styles.cardLg} ${styles.span6}`} />
    </div>
  );
}
